import {
  aFavoriteField,
  aFavoriteFieldPage,
  FavoriteFieldType,
  mockFavoriteFieldsQueryOperationQuery,
} from '__generated__';

import { INVENTORY_FAVORITE_FIELD_OVERRIDES } from '@sbu/configs.mocks';

export const handlers = [
  mockFavoriteFieldsQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        favoriteFields: aFavoriteFieldPage({
          objects: [
            aFavoriteField({
              fieldName: INVENTORY_FAVORITE_FIELD_OVERRIDES.fieldName,
              fieldType:
                INVENTORY_FAVORITE_FIELD_OVERRIDES.fieldType as FavoriteFieldType,
            }),
          ],
        }),
      })
    );
  }),
];
